import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.486 2.667A.333.333 0 0 0 6.152 3v5.667a.667.667 0 1 1-1.333 0V3a1.667 1.667 0 0 1 3.333 0v5A.667.667 0 1 1 6.82 8V3a.333.333 0 0 0-.333-.333",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.486 6a.333.333 0 0 0-.334.333v1.334a.667.667 0 1 1-1.333 0V6.333a1.667 1.667 0 1 1 3.333 0V8A.667.667 0 1 1 8.82 8V6.333A.333.333 0 0 0 8.486 6",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.486 6.667a.333.333 0 0 0-.334.333.667.667 0 1 1-1.333 0 1.667 1.667 0 0 1 3.333 0v1a.667.667 0 1 1-1.333 0V7a.333.333 0 0 0-.333-.333",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.643 6.928a1.91 1.91 0 0 1 2.334.287l.98.98a.667.667 0 0 1-.942.943l-.98-.98a.58.58 0 0 0-.706-.086.334.334 0 0 0-.12.45c.946 1.679 1.584 2.8 1.926 3.38l.243.4.128.198A3.34 3.34 0 0 0 8.29 14h1.194a3.334 3.334 0 0 0 3.33-3.168l.004-.165v-3a.334.334 0 0 0-.667 0 .667.667 0 0 1-1.333 0 1.667 1.667 0 0 1 3.333 0v3a4.667 4.667 0 0 1-4.667 4.667H8.152c-.02 0-.04-.005-.06-.007A4.67 4.67 0 0 1 4.56 13.47l-.167-.237-.133-.203c-.225-.345-.969-1.645-2.212-3.855a1.667 1.667 0 0 1 .595-2.247"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })